import React from "react";
import "../Styles/errorMessage.scss";

export default function FormError({error}) {
  return <p className="error-p">{error}</p> ;
}
